import CartItemSet from '../CartItemSet';
import CartItemSlot from '../CartItemSlot';
import cartItemsBle from './cartItemsBle';
import cartItemsNfc from './cartItemsNfc';
const CartItems = new Map([
    [CartItemSet.Ble, cartItemsBle],
    [CartItemSet.Nfc, cartItemsNfc],
]);
export { CartItems, cartItemsBle, CartItemSet, CartItemSlot, cartItemsNfc };
//# sourceMappingURL=index.js.map